import { render, staticRenderFns } from "./GamesSimple.vue?vue&type=template&id=630446c7"
import script from "./GamesSimple.vue?vue&type=script&lang=js"
export * from "./GamesSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports